import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    postAll: (context, botId) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.post.url + '/post/all/' + botId).then(response => {
            if (response.data.length !== 0) {
                context.commit('postAll', response.data)
            } else {
                context.commit('postAll', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get post' + error)
        })
    },
    postCreate: (context, data) => {
        let method = 'post'
        let url = constConf.post.url + '/post/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.post.url + '/post/update/' + data.id
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                let functionName = { put: 'postUpdate', post: 'postCreate' }
                context.commit(functionName[method], response.response.data)
                return response
            })
    },
    removePost: (context, index) => {
        let payload = context.getters.posts[index]
        axios({
            method: 'delete',
            url: constConf.post.url + '/post/delete/' + payload.id
        })
            .then((response) => {
                context.commit('removePost', payload.id)
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    }
}
